export default "__VITE_ASSET__BtbB$7s3__"